import { render, staticRenderFns } from "./createccount.vue?vue&type=template&id=15496ccd&"
import script from "./createccount.vue?vue&type=script&lang=js&"
export * from "./createccount.vue?vue&type=script&lang=js&"
import style0 from "./createccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports